import { render, staticRenderFns } from "./CustomerVoicePostList.vue?vue&type=template&id=2e52f88e&scoped=true&"
import script from "./CustomerVoicePostList.vue?vue&type=script&lang=js&"
export * from "./CustomerVoicePostList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerVoicePostList.vue?vue&type=style&index=0&id=2e52f88e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e52f88e",
  null
  
)

export default component.exports